import Vue from "vue"
import Router from "vue-router"
import i18n from "../i18n"
import hasParamContact from "@/middleware/hasParamContact"

Vue.use(Router);
const lang = i18n.locale;

const router = new Router({
    base: process.env.VUE_APP_PUBLIC_PATH,
    scrollBehavior () {
        var height = 0;

        try {
            const headerHeight = document.getElementsByTagName('header')[0].offsetHeight;
            const application = document.getElementsByClassName('application-scope')[0];
            const rect = application. getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            height = rect.top + scrollTop - headerHeight;
        } catch (error) {
            //
        }

        return { x: 0, y: height }
    },
    routes:[
        {
            path: "/"+lang+"/:slug",
            name: "app-overview",
            component: require("../pages/AppOverview.vue").default,
        },
        {
            path: "/"+lang+"/:slug/consumer/:id",
            name: "app-consumer",
            component: require("../pages/AppConsumer.vue").default,
        },
        {
            path: "/"+lang+"/:slug/consumer/:id/thanks",
            name: "app-consumer-thanks",
            component: require("../pages/AppConsumerThanks.vue").default,
            props: true,
            meta: {
                middleware: hasParamContact
            }
        },
        {
            path: "/"+lang+"/:slug/complaint/:id",
            name: "app-complaint",
            component: require("../pages/AppComplaint.vue").default,
        },
        {
            path: "/"+lang+"/:slug/complaint/:id/thanks",
            name: "app-complaint-thanks",
            component: require("../pages/AppComplaintThanks.vue").default,
            props: true,
            meta: {
                middleware: hasParamContact
            }
        },
        {
            path: "/"+lang+"/:slug/links/:id",
            name: "app-links",
            component: require("../pages/AppLinks.vue").default,
        },
        {
            path: "*",
            component: require("../pages/AppNotFound.vue").default,
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {

        return to.meta.middleware({ next: next, to :to });
    }

    return next();
});

export default router;